import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.search";
import "core-js/modules/es.string.split";
import _typeof from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/typeof";
import qs from 'querystring';

var trim = function trim(str) {
  return str ? str.replace(/(^\s*)|(\s*$)/g, '') : str;
};

export default {
  CARD_CLASS_PREFIX: '_card_',
  filterText: function filterText(text) {
    if (!text) return text;
    return text.replace(/src="\/\//g, "src=\"https://"); // 把相对协议改成https （ssr生成方式相对协议会有问题）
  },
  removeHttp: function removeHttp(src) {
    if (!src) return src; // 兼容 ssr

    var isLocalFile = typeof location === 'undefined' || /^(file|about)/.test(location.protocol);

    if (isLocalFile && /^\/\//.test(src)) {
      return src.replace(/^\/\//, 'https://');
    }

    return src.replace(/^http:/, 'https:');
  },
  getJSON: function getJSON(url) {
    return new Promise(function (resolve, reject) {
      var funName = "fun_cloud_seal_callback";

      window[funName] = function (data) {
        resolve(data);
        delete window[funName];
        document.body.removeChild(script);
      };

      var script = document.createElement('script');
      script.src = url.indexOf('?') !== -1 ? "".concat(url, "&callback=").concat(funName) : "".concat(url, "?callback=").concat(funName);

      script.onerror = function (e) {
        reject(e);
        delete window[funName];
        document.body.removeChild(script);
      };

      document.body.appendChild(script);
    });
  },
  getUrlParamObj: function getUrlParamObj() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.search.replace(/^\?/, '');
    return qs.parse(url);
  },
  getUrlParam: function getUrlParam(key) {
    var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : location.search.replace(/^\?/, '');
    return qs.parse(url)[key];
  },
  getVal: function getVal(obj) {
    var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    keys = keys.split('.');
    return keys.reduce(function (obj, key) {
      return obj && _typeof(obj) === 'object' ? obj[key] : undefined;
    }, obj);
  },
  getStyleObj: function getStyleObj() {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var temp = null;
    return trim(str).split(';').reduce(function (res, style) {
      style = trim(style);

      if (style) {
        temp = style.split(':');

        if (temp.length === 2) {
          res[temp[0]] = temp[1];
        }
      }

      return res;
    }, {});
  },
  getParamKeys: function getParamKeys(str) {
    var result = [];
    str.replace(/\$\{(\w+)\}/g, function (str, $1) {
      result.push($1);
    });
    return result;
  },
  replaceParams: function replaceParams(str) {
    var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (str || '').replace(/\${([\w\W]*?)}/g, function (str, $1) {
      try {
        var fun = new Function(Object.keys(ctx).join(','), "return ".concat($1));
        /* eslint-disable-line */

        return fun.apply(null, Object.values(ctx));
      } catch (e) {
        return str || '';
      } // return ctx[$1] || ''

    });
  },
  toString: function toString(val) {
    if (val === null || val === undefined) {
      return '';
    }

    return String(val);
  },
  // 默认不限制
  getMaxText: function getMaxText(text, maxLength) {
    if (!text || !maxLength) return text;
    var array = Array.from(text);
    var length = array.length;

    if (length > maxLength) {
      return array.slice(0, maxLength).join('') + '...';
    }

    return text;
  },
  createCardStyleTag: function createCardStyleTag(id, styleText) {
    // 兼容ssr
    if (!id || !styleText || typeof document === 'undefined') return;
    var dom = document.querySelector('#' + id);

    if (dom) {
      dom.innerHTML = styleText;
    } else {
      dom = document.createElement('style');
      dom.id = id;
      dom.innerHTML = styleText;
      document.head.appendChild(dom);
    }
  },
  parseJson: function parseJson(text) {
    var dft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    try {
      return JSON.parse(text);
    } catch (e) {
      return dft;
    }
  },
  getToken: function getToken(str) {
    if (!str) return;

    for (var i = 0, len = str.length, hash = 5381; i < len; ++i) {
      hash += (hash << 5) + str.charAt(i).charCodeAt();
    }

    return hash & 0x7fffffff;
  }
};